/* global System */

export default { GeoIpDetect: () => System.import('./index') }
